import { connect } from 'react-redux';

import EditLadsView from './EditLadsView';
import LadsState from './LadsState';


const mapStateToProps = state => {
  const { getLadsList, selectGroupedLads } = LadsState.selectors;
  return {
    ladsList: getLadsList(state),
    ladsGrouped: selectGroupedLads(state),
  };
}

const mapDispatchToProps = dispatch => {
  const { updateLadLabel } = LadsState.actionCreators;
  return {
    updateLadLabel: (lad, newLabel) => dispatch(updateLadLabel(lad, newLabel)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditLadsView);



// WEBPACK FOOTER //
// ./src/modules/lads/EditLadsContainer.js